<template lang="html">
    <!-- Bottom area -->
    <div class="row">
        <div class="my-3 d-flex col-12 p-0">
            <div class="d-flex flex-grow-1" :class="{'ml-3': !isInvoicing}">
                <button v-if="isIntegrated" type="button" class="btn action" @click="disableIntegration()"><i class="far fa-trash-alt fs-small mr-1" v-tooltip="{content:'Delete', boundariesElement:'window'}"></i> Disable integration</button>
            </div>

            <div class="d-flex justify-content-end" :class="{'mr-3': !isInvoicing}">
                <button v-if="showConnectionBtn" type="button" class="btn test-connection-min-width mr-2" :disabled="getIsTestingPrimaveraConnectionLoading || disableConnectionBtn " @click="testConnection()">
                    <div v-if="!getIsTestingPrimaveraConnectionLoading" class="ml-2">
                        Test Connection <i class="fa fa-plug fs-normal ml-2"></i>
                    </div>

                    <div v-else>
                        Testing <loader size="small" />
                    </div>
                </button>

                <button v-if="showPrevBtn" type="button" class="btn blue mr-2 pr-4" :disabled="false" @click="prevStep()"><i class="ico-arrow-left fs-normal ml-1"></i> Back</button>

                <div class="mr-2"><slot></slot></div>

                <button v-if="showSaveBtn" type="button" class="btn mr-2" :disabled="disableSaveBtn || loadingSaveBtn" @click="saveIntegration()">
                    <div v-if="!loadingSaveBtn" class="ml-2">
                        Save <i class="fs-normal ml-2"></i>
                    </div>

                    <div v-else>
                        Saving <loader size="small" />
                    </div>
                </button>

                <button v-if="showNextBtn" type="button" class="btn blue mr-2 pl-4" :disabled="disableNextBtn" @click="nextStep()">Next <i class="ico-arrow-right fs-normal ml-2 mr-1"></i></button>
               
                <button v-if="showConnectBtn" type="button" class="btn mx-2" :disabled="disableConnectBtn || loadingConnectBtn" @click="connectIntegration()">
                    <div v-if="!loadingConnectBtn" class="ml-2">
                        Connect <i class="fs-normal ml-2"></i>
                    </div>

                    <div v-else>
                        Connecting <loader size="small" />
                    </div>
                </button>

                <button type="button" class="btn tertiary" @click="close()">Close</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import loader from '@/tools/loaders/loader1'

    export default {
        props: {
            isIntegrated: {
                type: Boolean,
                default: false
            },
            isInvoicing: {
                type: Boolean,
                default: false
            },
            showSaveBtn: {
                type: Boolean,
                default: false
            },
            showNextBtn: {
                type: Boolean,
                default: false
            },
            showPrevBtn: {
                type: Boolean,
                default: false
            },
            showConnectionBtn: {
                type: Boolean,
                default: false
            },
            disableNextBtn: {
                type: Boolean,
                default: false
            },
            disableConnectionBtn: {
                type: Boolean,
                default: false
            },
            disableSaveBtn: {
                type: Boolean,
                default: false
            },
            loadingSaveBtn: {
                type: Boolean,
                default: false
            },
            showConnectBtn: {
                type: Boolean,
                default: false
            },
            disableConnectBtn: {
                type: Boolean,
                default: false
            },
            loadingConnectBtn: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapGetters([
                'getIsTestingPrimaveraConnectionLoading'
            ]),
        },
        methods: {
            disableIntegration() {
                this.$dialog.confirm(
                    '<h2 class="mb-3">Disable integration?</h2>\
                    <div>By disabling this feature, this integration will be <strong>disabled</strong> and you will lose access to its functionalities.</div>\
                    <div class="mt-4 mb-1">Are you sure you want to proceed?</div>',
                    {
                        okText: 'Disable',
                        customClass: 'red'
                    }
                ).then(() => {
                    this.$emit('disableIntegration');
                })
                .catch(() => {});
            },
            saveIntegration() {
                this.$emit('saveIntegration');
            },
            nextStep() {
                this.$emit('nextStep');
            },
            prevStep() {
                this.$emit('prevStep');
            },
            testConnection() {
                this.$emit('testConnection');
            },
            connectIntegration() {
                this.$emit('connectIntegration');
            },
            close() {
                this.$emit('close');
            }
        },
        components: {
            loader
        }
    }
</script>

<style lang="scss" scoped>
    .test-connection-min-width {
        min-width: 172px;
    }
</style>



// WEBPACK FOOTER //
// bottomArea.vue?9ef301e2